export const commonTimeFormat = 'MMMM D, YYYY [at] h:mmA';
export const dateTimeAtFormat = 'D MMM YYYY [at] h:mm A';
export const dateTimeFormat = 'MMMM D, YYYY h:mmA';
export const dateTimeWithEtFormat = 'MMM D, YYYY, h:mmA [ET]';
export const onlyDateTimeFormat = 'MMMM D, YYYY';
export const dateShortFormat = 'MMM DD, YYYY';
export const DEFAULT_DELIVERABLE_REVISION_LIMIT = 3;
export const DEFAULT_CURRENCY = 'USD';

/** CSS class for dashboard modals; when present, globals.scss adds top padding under the smart banner. */
export const DASHBOARD_SMART_BANNER_MODAL_CLASS =
  'dashboardModalWithSmartBannerPadding';

/** CSS class for dashboard review modals; when present, globals.scss adds margin-top so modal sits below nav + smart banner. */
export const DASHBOARD_REVIEW_MODAL_SMART_BANNER_MARGIN_CLASS =
  'dashboardReviewModalSmartBannerMargin';
